
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import StoryPage from '../pages/story/page';
import ContactPage from '../pages/contact/page';
import OrdersPage from '../pages/orders/page';
import CartPage from '../pages/cart/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/story',
    element: <StoryPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/cart',
    element: <CartPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
